// components/RouteTransition.tsx
import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface RouteTransitionProps {
  children: ReactNode;
}

export const RouteTransition: React.FC<RouteTransitionProps> = ({ children }) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.2 }}
    style={{ width: '100%', height: '100%' }}
  >
    {children}
  </motion.div>
);